import { GenerateTask, GraphMode } from '../../../../src/commonTypes';
import { ANALYSES_TYPES, AnalysisKey } from '../../../../src/commonConstants';

export const POSITIONING_GENERATE_TASKS: GenerateTask[] = [
	'persona',
	'motivations',
	'brainstorm',
	'proverb',
	'brand-colours',
	'brand-tone',
	'story',
	'character',
];

const GENERATE_TASKS_BY_MODE: Record<GraphMode, GenerateTask[]> = {
	inspire: ['brainstorm', 'common', 'haiku', 'ai-haiku', 'image-inspire', 'video-inspire'],
	ideate: ['persona', 'motivations', 'character', 'audience', 'proverb', 'brand-colours', 'brand-tone', 'story'],
	moodboard: ['image-synthesise'],
};

const ANALYSIS_GATED_IDEATE_TASKS: GenerateTask[] = [
	'persona',
	'character',
	'motivations',
	'audience',
];

const IDEA_BOX_SAVE_TASKS: GenerateTask[] = ['persona', 'character', 'motivations'];

export const isGenerateTaskVisible = ({
	task,
	graphMode,
	positioningMode = false,
	activeAnalysis = null,
}: {
	task: GenerateTask;
	graphMode: GraphMode;
	positioningMode?: boolean;
	activeAnalysis?: AnalysisKey | null;
}): boolean => {
	if (graphMode === 'ideate' && positioningMode) {
		return POSITIONING_GENERATE_TASKS.includes(task);
	}
	if (!GENERATE_TASKS_BY_MODE[graphMode].includes(task)) return false;
	if (graphMode !== 'ideate') return true;
	if (!ANALYSIS_GATED_IDEATE_TASKS.includes(task) || !activeAnalysis) return true;
	return Boolean(ANALYSES_TYPES[activeAnalysis]?.generate?.includes(task));
};

export const generateResultSaveDestination = ({
	generateTask,
	graphMode,
	positioningMode = false,
}: {
	generateTask: GenerateTask;
	graphMode?: GraphMode | null;
	positioningMode?: boolean;
}): 'positioning-map' | 'idea-box' | null => {
	const onIdeate = graphMode === 'ideate' || positioningMode;
	if (onIdeate && POSITIONING_GENERATE_TASKS.includes(generateTask)) {
		return 'positioning-map';
	}
	if (IDEA_BOX_SAVE_TASKS.includes(generateTask)) {
		return 'idea-box';
	}
	return null;
};
